<template>
		<el-dialog title="新建/编辑模块" :visible.sync="visible" :before-close="beforeClose" width="70%">
			<el-form
      :inline="true"
      :model="addNewSourceForm"
      label-width="150px"
      label-position="right"
      style="overflow-y: scroll; height: 50vh"
    >
      <el-row>
        <el-form-item label="模块名称">
          <el-input v-model="addNewSourceForm.moduleName"></el-input>
        </el-form-item>
		<el-form-item label="排序号">
          <el-input v-model="addNewSourceForm.disOrder"></el-input>
        </el-form-item>
      </el-row>
      
      <el-row>	
        <el-form-item label="导航路径" style="width: 100%;">
          	<el-input v-model="addNewSourceForm.url" style="width: 800px;"></el-input>
        </el-form-item>	      
      </el-row>
	  
      <el-row>
        <my-upload-file-form-item v-model="addNewSourceForm.sample" label="图片" subDir="icon\" />
      </el-row>
      <el-row>
        <el-form-item label="是否Tab页">         
		  <el-switch  v-model="addNewSourceForm.isTab"  on-color="#00A854"  on-text="是"  on-value="1" off-color="#F04134" off-text="否" off-value="0"></el-switch>
        </el-form-item>
		<el-form-item label="是否内容类">
		  <el-switch  v-model="addNewSourceForm.isContent"  on-color="#00A854"  on-text="是"  on-value="1" off-color="#F04134" off-text="否" off-value="0"></el-switch>
        </el-form-item>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('update:visible', false)">返回</el-button>
      <el-button type="primary" @click="onConfirm">确定</el-button>
    </div>
		</el-dialog>

</template>


<script>
import { mapGetters } from "vuex";
import { getToken } from "@/utils/auth";
import MyUploadFileFormItem from "@/components/MyUploadFileFormItem";

export default {
  name: "AddNewSourceDialog",
  components: { MyUploadFileFormItem }, //,todoItem,  SourcePrice
  computed: { ...mapGetters([]) },

  props: {
    visible: { type: Boolean, default: false, required: true },
    formExtra: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  watch: {
    visible(newValue) {   
      if (newValue) {
        if (this.formExtra.moduleId){
          this.addNewSourceForm = this.formExtra;
        }
        console.log('bb',this.addNewSourceForm);
      }
    },
  },
  data() {
    return {
      addNewSourceForm: {
        moduleId: "",
		moduleName: "",
		sample: [],
		url: "",
		isTab:0,
		disOrder:0,
		isContent:0,
      },
    };
  },
  async beforeCreate() {
        
  },
  methods: {
      
    async onConfirm() {
      
      const {
				moduleName, disOrder, url, showModuleIds
            } = this.addNewSourceForm;
      if (!moduleName?.trim()) {
			this.$message.warning('请输入模块名称')
			return;
	  }
	  if (!disOrder) {
			this.$message.warning('请输入排序号')
			return;
	  }
      if (!url?.trim()) {
					this.$message.warning('请输入导航路径')
					return;
      }
      
      await this.$store.dispatch("setting/moduleModify", {
        form: this.addNewSourceForm,
      });
      this.$message.success("编辑成功");
      await this.$store.dispatch("setting/moduleList");
      // await this.$store.dispatch('products/sourceAnalysisSimple');
      this.beforeClose();
    },

    beforeClose() {
      this.$emit("update:visible", false);
    },

  },
};
</script>

<style scoped>

</style>